import React from 'react';

function Gisting({ currLang }) {
  return (
    <div style={{ padding: '4rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>{currLang === "IS" ? "Gisting á Eskifirði" : "Accomodation in Eskifjörður"}</h1>

      <p>{currLang === "IS" ?
        "Hérna er hægt að vita allt um hvar er best að gista á Eskifirði."
        :
        "Here is all the information about where it is best to stay at Eskifjörður."}
      </p>
      <h3>Mjóeyri</h3>
      <p>{currLang === "IS" ?
        "Hægt er að leigja kofa á Mjóeyri. " +
        "Kofarnir eru ýmist með gistipláss fyrir allt að 4 eða 6 manns og þeim fylgir einnig lítið eldhús. Berglind hefur verið svo væn að taka frá kofana á Mjóeyri fyrir gesti okkar en það þarf þá að bóka fyrir 30.04.2026. " +
        "Hægt er að skoða Mjóeyri nánar á "
        :
        "It is possible to rent a cabin at Mjóeyri. " +
        "The cabins are equipped with sleeping arrangements for 4 or 6 people and they have a small kitchen included. Berglind (the owner) has been so kind to reserve the cabins for our guests, but they will have to be reserved before the 30th of April, 2026. " +
        "You can find more information about Mjóeyri at "}
        <a href='https://www.mjoeyri.is/' target='_blank'>Mjóeyri.is</a>.
        <br />
        {currLang === "IS" ?
          "Hægt er að bóka gistingu á Mjóeyri með því að senda tölvupóst á mjoeyri@mjoeyri.is og minnast á það að þetta sé fyrir brúðkaupið okkar."
          :
          "You can book the accommodation at Mjóeyri by sending an email to mjoeyri@mjoeyri.is and mentioning that this is for our wedding."
        }
      </p>
      <h3>
        {currLang === "IS" ?
          "Hótel Eskifjörður"
          :
          "Hotel Eskifjörður"
        }
      </h3>
      <p>
        {currLang === "IS" ?
          "Á Eskifirði er einnig hægt að gista á Hótel Eskifirði. Þar er hægt að bóka klassískt hótelherbergi og láta vel um sig fara."
          :
          "In Eskifjörður, you can also stay at Hotel Eskifjörður. " +
          "There you can book a classic hotel room and be well taken care of."
        }
      </p>
      <h3>{currLang === "IS" ? "Tjaldsvæðið" : "Camping Area"}</h3>

      <p>{currLang === "IS" ?
        "Tjaldsvæðið á Eskifirði er staðsett nálægt sundlauginni svo það er alltaf stutt í sundsprett og sturtu ef fólk kýs að gista í tjaldi eða öðru þar til gerðu farartæki."
        :
        "The camping area in Eskifjörður is located near the swimming pool, so it is always a short distance to a swim and shower if people choose to camp in a tent or other camping suited vehicle."}
      </p>
      <h3>{currLang === "IS" ? "Aðrir gististaðir" : "Other accomodation"}</h3>
      <p>{currLang === "IS" ? "Eins og í flestum betri bæjum Íslands þá er eflaust eihverja gistingu að fá á Airbnb eða öðrum álíka vefsíðum. Það sakar ekki að skoða það ef fólk er til í svoleiðis." :
        "As in most of the better towns in Iceland, there is probably some accommodation available on Airbnb or similar websites. It doesn't hurt to check that out if people are into that sort of thing."
      }
        <br /><br />
        {currLang === "IS" ?
          "Einnig er hægt að skoða gistingu í nærliggjandi bæjarfélögum, en þar sem Eskifjörður er nafli alheimsins, þá er ekki sérstaklega mælt með því (og þá þarftu að hafa aðgengi að bíl eða skutli)."
          :
          "It is also possible to check accommodation in nearby towns, but as Eskifjörður is the center of the universe, it is not recommended (and you need to have access to a car or someone to drive you around)."
        }
      </p>
      <div style={{ gap: '1rem', flexWrap: 'wrap', paddingTop: '2rem' }}>
        <img
          src="/newsletter-images/eskifjordurKort.png"
          alt="Map of Eskifjörður"
          style={{ maxWidth: '500px', width: '100%', height: 'auto', borderRadius: '8px', margin: '0 auto' }}
        />
      </div>
    </div>
  );
}

export default Gisting;